module.exports = __webpack_public_path__ + "static/media/ic_instagram.703cd6f7.svg";